module.exports = __webpack_public_path__ + "img/radiografia4.27585a10.jpg";